const initialState = {
    noData: false,
    scopeList: [],
    fetching: false,
    fetched: false,
    error: null
}

export function scopesReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_SCOPE_LIST_TOKEN": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "FETCH_SCOPE_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "FETCH_SCOPE_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "FETCH_SCOPE_LIST_FULFILLED": {
            return { ...state, fetching: false, fetched: true, noData: action.payload.data.length == 0, scopeList: action.payload.data }
        }

        case "FETCH_SCOPE_ERROR": {
            return { ...state, error: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        default:
            return state
    }
}
